import PropTypes from 'prop-types';
import React from 'react';
import { calculatePercentage } from '../../../../lib/utils.js';

ProjectCompletion.propTypes = {
  initiatives: PropTypes.arrayOf(
    PropTypes.shape({
      completionTracked: PropTypes.bool.isRequired,
      initiativeParticipation: PropTypes.shape({
        leavesCount: PropTypes.number.isRequired,
        leavesCompletedCount: PropTypes.number.isRequired,
      }),
    })
  ).isRequired,
};

function ProjectCompletion({ initiatives }) {
  let anyCompletionTracked = false;
  let participationCount = 0;
  let participationCompletedCount = 0;

  for (const initiative of initiatives) {
    if (!initiative.completionTracked) {
      continue;
    }
    anyCompletionTracked = true;

    participationCount += initiative.participationCount;
    participationCompletedCount += initiative.participationCompletedCount;
  }

  if (!anyCompletionTracked) {
    return <strong>—</strong>;
  }

  const completionPercentage = calculatePercentage(
    participationCompletedCount,
    participationCount
  );
  return (
    <React.Fragment>
      <div className="strong">{completionPercentage}%</div>
      <div className="text-details">
        {participationCompletedCount} /{participationCount}
      </div>
    </React.Fragment>
  );
}

export default ProjectCompletion;
